var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:ArtifaktElement;src:url(" + escape(require("./fonts/Artifakt_Element_Regular.woff2")) + ")}", ""]);

// exports
